import { useContext, useEffect, useMemo, useState } from 'react'

import {
  BabyPoopEmbed,
  BabyPoopForm,
  useHealthToolsCache,
} from '@hhgtech/hhg-components'
import { BabyPoopEmbedProps } from '@hhgtech/hhg-components/components/molecules/embeddedHeathToolCards/baby-poop'
import { BabyPoopFormProps } from '@hhgtech/hhg-components/components/molecules/healthTools/form/babyPoopForm'
import router from 'next/router'

import { callApiNew } from 'api/axios'
import { formatBabyPoopPage } from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { redirectToSSOWithReturnUrl } from 'api/utils/redirects'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { basePath } from 'interfaces/constants'
import { HEALTH_TOOL_TYPE } from 'interfaces/constants/healthTools'
import { BabyPoopPage } from 'interfaces/types'
import { AppContext } from 'state/appContext'

import { HealthToolCardEmbedProps } from '../types'

type CommonProps = {
  isSide?: boolean
  direction?: 'row' | 'column' | 'auto'
  sponsorLogo?: string
} & HealthToolCardEmbedProps

export type BabyPoopCardWrapperProps =
  | ({ onlyUseForm: true } & Partial<BabyPoopFormProps> & CommonProps)
  | ({ onlyUseForm?: false } & Partial<BabyPoopEmbedProps> & CommonProps)

export const BabyPoopCard = ({
  isSide,
  direction,
  sponsorLogo,
  onlyUseForm,
  ...props
}: BabyPoopCardWrapperProps) => {
  const currentUrl = useCurrentUrl()
  const { locale } = useRouterExtend()
  const [babyPoopPage, setBabyPoopPage] = useState<BabyPoopPage>(
    {} as BabyPoopPage,
  )

  const { getHealthToolLink } = useHealthToolsCache(locale)
  const babyPoopUrl = useMemo(
    () => getHealthToolLink(HEALTH_TOOL_TYPE.BABY_POOP),
    [getHealthToolLink],
  )
  const { state } = useContext(AppContext) || {}
  const { userInfo } = state || {}
  useEffect(() => {
    ;(async () => {
      const res = await callApiNew(PATHS.HEALTH_TOOL.GET_HEALTH_TOOL_BABY_POOP)
      setBabyPoopPage(formatBabyPoopPage(res?.data) as BabyPoopPage)
    })()
  }, [])
  const onClickFindOut = () => {
    const destination = `${
      typeof window !== 'undefined' ? window.location.origin : ''
    }${basePath}${babyPoopUrl}`
    if (!userInfo?.id) {
      redirectToSSOWithReturnUrl(destination, 'baby-poop-checking')
    } else {
      router.push(destination)
    }
  }

  return babyPoopUrl ? (
    onlyUseForm ? (
      <BabyPoopForm
        currentUrl={currentUrl}
        babyPoopPage={babyPoopPage as any}
        onClickFindOut={onClickFindOut}
        {...props}
      />
    ) : (
      <BabyPoopEmbed
        babyPoopPage={babyPoopPage as any}
        formProps={{
          babyPoopPage: babyPoopPage as any,
          currentUrl,
          onClickFindOut,
          sponsorLogo,
        }}
        {...props}
      />
    )
  ) : null
}
